<template>
    <div class="fatturazione-dashboard">
        <div v-if="isLoading">Caricamento in corso...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else>
            <h1 class="dashboard-title">Validazione Fatture GAS</h1>

            <div class="cards-container">
                <div class="info-card" :class="{ 'solo-header': !visibileSezioni.dettagliFattura }">
                    <div class="info-card-header" @click="toggleSezione('dettagliFattura')"
                        :class="{ 'solo': !visibileSezioni.dettagliFattura }">
                        <div class="header-content">
                            <h3 class="section-title">Dettagli Fattura</h3>
                            <span class="toggle-icon">
                                {{ visibileSezioni.dettagliFattura ? '▲' : '▼' }}
                            </span>
                        </div>
                    </div>
                    <div class="info-card-content" v-if="visibileSezioni.dettagliFattura">
                        <div class="info-row" v-for="(label, key) in intestazioniFattura" :key="key">
                            <span class="info-label">{{ label }}</span>
                            <span class="info-value">
                                <template v-if="key === 'numero'">
                                    <span class="numero-fattura-container">
                                        <span class="numero-fattura">{{ dettagliFattura[key] || '-' }}</span>
                                        <div class="fattura-actions">
                                            <button @click="downloadPDF()" class="action-btn download-btn"
                                                title="Scarica PDF">
                                                ⬇
                                            </button>
                                            <button @click="viewPDF()" class="action-btn view-btn"
                                                title="Visualizza Dettaglio">
                                                👁
                                            </button>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="key === 'creation_time'">
                                    {{ formatDate(dettagliFattura[key]) }}
                                </template>
                                <template v-else-if="key === 'mese_fatturazione'">
                                    {{ dettagliFattura[key] }}
                                </template>
                                <template v-else-if="key === 'imponibile' || key === 'totale'">
                                    {{ formatCurrency(dettagliFattura[key]) }}
                                </template>
                                <template v-else-if="key === 'preview_totale_qta'">
                                    {{ dettagliFattura[key] }} mc
                                </template>
                                <template v-else-if="key === 'coeffC'">
                                    {{ formatNumber(dettagliFattura[key]) }}
                                </template>
                                <template v-else-if="key === 'prog_annuo'">
                                    {{ formatNumber(dettagliFattura[key]) }} mc
                                </template>
                                <template v-else>
                                    {{ dettagliFattura[key] || '-' }}
                                </template>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="info-card" :class="{ 'solo-header': !visibileSezioni.dettagliCliente }">
                    <div class="info-card-header" @click="toggleSezione('dettagliCliente')"
                        :class="{ 'solo': !visibileSezioni.dettagliCliente }">
                        <div class="header-content">
                            <h3 class="section-title">Dettagli Cliente</h3>
                            <span class="toggle-icon">
                                {{ visibileSezioni.dettagliCliente ? '▲' : '▼' }}
                            </span>
                        </div>
                    </div>
                    <div class="info-card-content" v-if="visibileSezioni.dettagliCliente">
                        <div class="info-row">
                            <span class="info-label">Cliente:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);"
                                    @click="navigateToClienteDetail(dettagliFattura.cliente_id)" class="link-pod"
                                    v-if="dettagliFattura.cliente_id">
                                    {{ formatNomeCliente(dettagliFattura.ragsoc, dettagliFattura.nome,
                                        dettagliFattura.cognome) }}
                                </a>
                                <span v-else>
                                    {{ formatNomeCliente(dettagliFattura.ragsoc, dettagliFattura.nome,
                                        dettagliFattura.cognome) }}
                                </span>
                            </span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Codice PDR:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);" @click="navigateToPdrDetail(dettagliFattura.cod_pdr)"
                                    class="link-pod" v-if="dettagliFattura.cod_pdr && dettagliFattura.cod_pdr > 0">
                                    {{ dettagliFattura.pdr_code || dettagliFattura.cod_pdr }}
                                </a>
                                <span v-else class="text-muted">
                                    {{ dettagliFattura.pdr_code || 'PDR non assegnato' }}
                                </span>
                            </span>
                        </div>

                        <!-- Informazioni specifiche per il Gas -->
                        <div class="info-row" v-if="dettagliFattura.coeffC">
                            <span class="info-label">Coefficiente C:</span>
                            <span class="info-value">{{ formatNumber(dettagliFattura.coeffC) }}</span>
                        </div>

                        <div class="info-row" v-if="dettagliFattura.prog_annuo">
                            <span class="info-label">Progressivo Annuo:</span>
                            <span class="info-value">{{ formatNumber(dettagliFattura.prog_annuo) }} mc</span>
                        </div>

                        <div class="info-row" v-if="dettagliFattura.preview_totale_qta">
                            <span class="info-label">Quantità Fatturata:</span>
                            <span class="info-value">{{ formatNumber(dettagliFattura.preview_totale_qta) }} mc</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">Rappresentante:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);"
                                    @click="navigateToRappresentanteDetail(dettagliFattura.rappresentante_id)"
                                    class="link-pod" v-if="dettagliFattura.rappresentante">
                                    {{ dettagliFattura.rappresentante }}
                                </a>
                                <span v-else>Non assegnato</span>
                            </span>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Agente:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);" @click="navigateToAgenteDetail(dettagliFattura.agente_id)"
                                    class="link-pod" v-if="dettagliFattura.agente">
                                    {{ dettagliFattura.agente }}
                                </a>
                                <span v-else>Non assegnato</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Letture Gas</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoLetture')">
                        {{ visibileSezioni.bloccoLetture ? '▲' : '▼' }}
                    </span>

                </div>
                <div v-if="visibileSezioni.bloccoLetture">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>PDR</th>
                                    <th>Data Misura</th>
                                    <th>Data Comunicazione</th>
                                    <th>Consumo</th>
                                    <th>Coefficiente</th>
                                    <th>Consumo SMC</th>
                                    <th>Tipo Lettura</th>
                                    <th>Autolettura</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!dettagliFattura.letture || !dettagliFattura.letture.length">
                                    <td colspan="11" class="no-data-message">Nessuna lettura disponibile</td>
                                </tr>
                                <tr v-else v-for="(lettura, index) in paginatedLetture" :key="lettura.id || index">
                                    <td>{{ lettura.id || '-' }}</td>
                                    <td>{{ lettura.pdr || '-' }}</td>
                                    <td>{{ formatDate(lettura.data_misura) }}</td>
                                    <td>{{ formatDate(lettura.data_comunicazione) }}</td>
                                    <td>{{ formatNumber(lettura.consumo) }}</td>
                                    <td>{{ formatNumber(lettura.coefficiente) }}</td>
                                    <td>{{ formatNumber(lettura.consumo_smc) }}</td>
                                    <td>{{ lettura.tipo_lettura || '-' }}</td>
                                    <td>{{ formatBoolean(lettura.autolettura) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-container"
                        v-if="dettagliFattura.letture && dettagliFattura.letture.length > itemsPerPage">
                        <div class="pagination-info">
                            Elementi {{ (currentPageLetture - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageLetture * itemsPerPage, dettagliFattura.letture.length) }}
                            di {{ dettagliFattura.letture.length }}
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageLetture = 1"
                                :disabled="currentPageLetture === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageLetture--"
                                :disabled="currentPageLetture === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageLetture }} / {{ totalPagesLetture }}</span>
                            <button class="pagination-btn" @click="currentPageLetture++"
                                :disabled="currentPageLetture === totalPagesLetture">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageLetture = totalPagesLetture"
                                :disabled="currentPageLetture === totalPagesLetture">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MENSILITÀ REALI GAS CON PAGINAZIONE -->
            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Mensilità Reali</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoMensilita')">
                        {{ visibileSezioni.bloccoMensilita ? '▲' : '▼' }}
                    </span>
                </div>
                <div v-if="visibileSezioni.bloccoMensilita">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>COD PDR</th>
                                    <th>Data Comunicazione</th>
                                    <th>Data</th>
                                    <th>Consumo</th>
                                    <th>Coefficiente</th>
                                    <th>Consumo SMC</th>
                                    <th>Used</th>
                                    <th>Fattura</th>
                                    <th>Tipologia</th>
                                    <th>Data Insert</th>
                                    <th>Palleggia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!dettagliFattura.mensilita_reali || !dettagliFattura.mensilita_reali.length">
                                    <td colspan="12" class="no-data-message">Nessuna mensilità disponibile</td>
                                </tr>
                                <tr v-else v-for="(row, index) in paginatedMensilita" :key="row.id || index">
                                    <td>{{ row.id || '-' }}</td>
                                    <td>{{ row.cod_pdr || '-' }}</td>
                                    <td>{{ formatDate(row.data_comunicazione) }}</td>
                                    <td>{{ formatDate(row.data) }}</td>
                                    <td>{{ formatNumber(row.consumo) }}</td>
                                    <td>{{ formatNumber(row.coefficiente) }}</td>
                                    <td>{{ formatNumber(row.consumo_smc) }}</td>
                                    <td>{{ row.used || '-' }}</td>
                                    <td>{{ row.numero_fattura || '-' }}</td>
                                    <td>{{ row.tipologia || '-' }}</td>
                                    <td>{{ formatDate(row.data_insert) }}</td>
                                    <td class="text-center">
                                        <button 
                                            v-if="!row.used"
                                            @click="onMensilitaRealeUsed2(dettagliFattura.pod_id, row.id_mensilita)"
                                            class="action-btn used2-btn"
                                            title="Palleggia">
                                            ⚠
                                        </button>
                                        <span v-else class="status-icon success">✓</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-container"
                        v-if="dettagliFattura.mensilita_reali && dettagliFattura.mensilita_reali.length > itemsPerPage">
                        <div class="pagination-info">
                            Elementi {{ (currentPageMensilita - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageMensilita * itemsPerPage, dettagliFattura.mensilita_reali.length) }}
                            di {{ dettagliFattura.mensilita_reali.length }}
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageMensilita = 1"
                                :disabled="currentPageMensilita === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageMensilita--"
                                :disabled="currentPageMensilita === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageMensilita }} / {{ totalPagesMensilita }}</span>
                            <button class="pagination-btn" @click="currentPageMensilita++"
                                :disabled="currentPageMensilita === totalPagesMensilita">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageMensilita = totalPagesMensilita"
                                :disabled="currentPageMensilita === totalPagesMensilita">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fatture-table-container"
                v-if="dettagliFattura.dettagli_fattura && dettagliFattura.dettagli_fattura.length">
                <div class="fatture-table-header">
                    <h3 class="section-title">Dettagli Fattura</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoDettagli')">
                        {{ visibileSezioni.bloccoDettagli ? '▲' : '▼' }}
                    </span>
                </div>
                <div v-if="visibileSezioni.bloccoDettagli">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>Cod Voce</th>
                                    <th>Descrizione</th>
                                    <th>Qtà</th>
                                    <th>Unitario</th>
                                    <th>Totale</th>
                                    <th>IVA %</th>
                                    <th>Importo IVA</th>
                                    <th>Totale Ivato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dettaglio, index) in paginatedDettagli" :key="dettaglio.id || index">
                                    <td>{{ dettaglio.cod_voce || '-' }}</td>
                                    <td class="voce-nome">
                                        <div class="voce-info">
                                            <div v-if="dettaglio.descrizione" class="voce-descrizione">
                                                {{ dettaglio.descrizione }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ formatNumber(dettaglio.qta) }}</td>
                                    <td>{{ formatCurrency(dettaglio.unitario) }}</td>
                                    <td>{{ formatCurrency(dettaglio.totale) }}</td>
                                    <td>{{ formatNumber(dettaglio.iva) }}%</td>
                                    <td>{{ formatCurrency(dettaglio.importo_iva) }}</td>
                                    <td class="font-bold">{{ formatCurrency(dettaglio.totale_ivato) }}</td>
                                </tr>
                            </tbody>
                            <tfoot
                                v-if="dettagliFattura.dettagli_fattura && dettagliFattura.dettagli_fattura.length > 0">
                                <tr class="totali-row">
                                    <td colspan="4"><strong>TOTALI:</strong></td>
                                    <td><strong>{{ formatCurrency(totaleImponibile) }}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>{{ formatCurrency(totaleGenerale) }}</strong></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div class="pagination-container"
                        v-if="dettagliFattura.dettagli_fattura && dettagliFattura.dettagli_fattura.length > itemsPerPage">
                        <div class="pagination-info">
                            Elementi {{ (currentPageDettagli - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageDettagli * itemsPerPage, dettagliFattura.dettagli_fattura.length) }}
                            di {{ dettagliFattura.dettagli_fattura.length }}
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageDettagli = 1"
                                :disabled="currentPageDettagli === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageDettagli--"
                                :disabled="currentPageDettagli === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageDettagli }} / {{ totalPagesDettagli }}</span>
                            <button class="pagination-btn" @click="currentPageDettagli++"
                                :disabled="currentPageDettagli === totalPagesDettagli">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageDettagli = totalPagesDettagli"
                                :disabled="currentPageDettagli === totalPagesDettagli">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Dettaglio Fatturazione</h3>
                </div>

                <div class="fatture-summary">
                    <div class="summary-item">
                        <span class="summary-label">Media Fatture</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.media) }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">Ultima Fattura</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.lastfatt) }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">Imponibile Massimo</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.maxfatt) }}</span>
                    </div>
                </div>

                <div class="fatture-table-wrapper">
                    <table class="fatture-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Numero</th>
                                <th>Data</th>
                                <th>Mese Fatturazione</th>
                                <th>Cliente</th>
                                <th>PDR</th>
                                <th>Imponibile</th>
                                <th>Totale</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!dettagliFattura.fatture_tabella || dettagliFattura.fatture_tabella.length === 0">
                                <td colspan="7" class="no-data-message">Nessuna fattura disponibile</td>
                            </tr>
                            <tr v-else v-for="fattura in dettagliFattura.fatture_tabella" :key="fattura.id">
                                <td>{{ fattura.id }}</td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToFatturaDetail(fattura.numero)"
                                        class="link-pod">
                                        {{ fattura.numero }}
                                    </a>
                                </td>
                                <td>{{ formatDate(fattura.data) }}</td>
                                <td>{{ formatDate(fattura.mese_fatturazione) }}</td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToClienteDetail(fattura.cliente_id)"
                                        class="link-pod">
                                        {{ fattura.cliente_nome }}
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToPdrDetail(fattura.pdr_id)"
                                        class="link-pod">
                                        {{ fattura.pdr_code }}
                                    </a>
                                </td>
                                <td>{{ formatCurrency(fattura.imponibile) }}</td>
                                <td>{{ formatCurrency(fattura.totale) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- VALIDAZIONE -->
            <div class="fattura-controls-container">
                <div class="approval-actions">
                    <button class="approval-button approve-button" @click="updateStatoFattura('approva')">
                        Approva Fattura
                    </button>
                    <button class="approval-button reject-button" @click="updateStatoFattura('scarta')">
                        Scarta Fattura
                    </button>
                </div>
            </div>

            <div v-if="showValidazioneModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-header"
                        :class="azioneValidazione === 'approva' ? 'modal-header-approve' : 'modal-header-reject'">
                        <h3>{{ azioneValidazione === 'approva' ? 'Approva' : 'Scarta' }} Fattura</h3>
                        <button class="close-button" @click="showValidazioneModal = false">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-message">
                            Inserisci una nota per {{ azioneValidazione === 'approva' ? 'l\'approvazione' : 'lo scarto'
                            }} della fattura.
                        </div>
                        <div class="form-group">
                            <label for="noteValidazione">Note (obbligatorie):</label>
                            <textarea id="noteValidazione" v-model="noteValidazione"
                                placeholder="Inserisci le note (obbligatorio - minimo 5 caratteri)"
                                :class="azioneValidazione === 'approva' ? 'textarea-approve' : 'textarea-reject'"
                                rows="4"></textarea>
                        </div>
                        <div v-if="noteValidazioneError" class="error-message">
                            {{ noteValidazioneError }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-cancel" @click="showValidazioneModal = false">
                            Annulla
                        </button>
                        <button class="btn-submit"
                            :class="azioneValidazione === 'approva' ? 'btn-approve' : 'btn-reject'"
                            @click="validaFattura">
                            Conferma {{ azioneValidazione === 'approva' ? 'Approvazione' : 'Scarto' }}
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="showSuccessModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-header"
                        :class="successAction === 'approva' ? 'modal-header-approve' : 'modal-header-reject'">
                        <h3>Operazione Completata</h3>
                        <button class="close-button" @click="showSuccessModal = false">×</button>
                    </div>
                    <div class="compact-body">
                        <div class="success-message">
                            Fattura {{ successAction === 'approva' ? 'approvata' : 'scartata' }} con successo!
                        </div>
                        <div class="success-details">
                            La fattura è stata processata correttamente e aggiornata nel sistema.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-secondary" @click="showSuccessModal = false">
                            Chiudi
                        </button>
                        <button :class="successAction === 'approva' ? 'btn-success-approve' : 'btn-success-reject'"
                            @click="loadNextInvoice">
                            Carica Prossima Fattura
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PreviewFattureGasService from '@/services/ask-fatturazione/previewfatturegas-service';

export default {
    name: 'PreviewFattureGas',
    data() {
        return {
            previewFattureService: null,
            dettagliFattura: {
                letture: [],
                mensilita_reali: [],
                dettagli_fattura: [],
                fatture_tabella: []
            },
            isLoading: true,
            error: null,
            itemsPerPage: 10,
            currentPageLetture: 1,
            currentPageMensilita: 1,
            currentPageDettagli: 1,
            noteValidazioneError: null,
            visibileSezioni: {
                dettagliFattura: true,
                dettagliCliente: true,
                bloccoLetture: true,
                bloccoMensilita: true,
                bloccoDettagli: true
            },
            intestazioniFattura: {
                numero: 'Numero Fattura',
                creation_time: 'Data',
                coeffC: 'Coefficiente C',
                preview_totale_qta: 'Quantità Fatturata',
                prog_annuo: 'Progressivo Annuo',
                mese_fatturazione: 'Mese Fatturazione',
                imponibile: 'Imponibile',
                totale: 'Totale',
                pay: 'Metodo Pagamento',
                scadenza: 'Scadenza'
            },
            showValidazioneModal: false,
            azioneValidazione: 'approva',
            noteValidazione: '',
            validazioneInProgress: false,
            validazioneError: null,
            showSuccessModal: false,
            successAction: 'approva',
            successFatturaNumero: '',
            successFatturaCliente: '',
            showStoriaValidazioniModal: false,
            storiaValidazioni: [],
            caricamentoStoriaValidazioni: false,

            loadRequestSeq: 0,
        };
    },

    computed: {
        totalPagesLetture() {
            const letture = this.dettagliFattura?.letture;
            if (!letture || !Array.isArray(letture) || letture.length === 0) return 1;
            return Math.ceil(letture.length / this.itemsPerPage);
        },
        paginatedLetture() {
            const letture = this.dettagliFattura?.letture;
            if (!letture || !Array.isArray(letture)) return [];
            const start = (this.currentPageLetture - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return letture.slice(start, end);
        },

        totalPagesMensilita() {
            const mensilita = this.dettagliFattura?.mensilita_reali;
            if (!mensilita || !Array.isArray(mensilita) || mensilita.length === 0) return 1;
            return Math.ceil(mensilita.length / this.itemsPerPage);
        },
        paginatedMensilita() {
            const mensilita = this.dettagliFattura?.mensilita_reali;
            if (!mensilita || !Array.isArray(mensilita)) return [];
            const start = (this.currentPageMensilita - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return mensilita.slice(start, end);
        },

        totalPagesDettagli() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli) || dettagli.length === 0) return 1;
            return Math.ceil(dettagli.length / this.itemsPerPage);
        },
        paginatedDettagli() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return [];
            const start = (this.currentPageDettagli - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return dettagli.slice(start, end);
        },

        totaleImponibile() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.totale) || 0), 0);
        },
        totaleIva() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.importo_iva) || 0), 0);
        },
        totaleGenerale() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.totale_ivato) || 0), 0);
        }
    },

    methods: {
        getCheckFattura() {
            const raw = this.$route?.query?.checkFattura;
            const parsed = Number(raw);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 3;
        },

        applyFatturaResponse(response) {
            if (!response) {
                throw new Error('Nessuna risposta dal server');
            }

            if (!response.data) {
                throw new Error('Risposta dal server senza dati');
            }

            if (response.data.success === false) {
                const errorMsg = response.data.message || 'Operazione fallita';
                this.error = errorMsg;
                return false;
            }

            const data = response.data.data || response.data;
            if (!data) {
                throw new Error('Nessun dato fattura GAS ricevuto');
            }

            if (!data.autofattura_id && !data.id && !data.numero) {
                throw new Error('Dati fattura GAS incompleti o non validi');
            }

            this.dettagliFattura = {
                ...data,
                letture: Array.isArray(data.letture) ? data.letture : [],
                mensilita_reali: Array.isArray(data.mensilita_reali) ? data.mensilita_reali : [],
                dettagli_fattura: Array.isArray(data.dettagli_fattura) ? data.dettagli_fattura : [],
                fatture_tabella: Array.isArray(data.fatture_tabella) ? data.fatture_tabella : []
            };

            this.resetPagination();
            return true;
        },

        handleLoadError(error) {
            const message = (error && typeof error === 'object' && 'message' in error && error.message)
                ? String(error.message)
                : String(error);

            if (message.includes('Server non raggiungibile') || message.includes('ECONNREFUSED')) {
                this.error = `🔌 ${message}\n\n💡 Soluzioni:\n• Avvia il server Laravel: php artisan serve --port=8001\n• Verifica che sia raggiungibile su http://localhost:8001\n• Controlla che non ci siano firewall che bloccano la porta 8001`;
            } else if (message.includes('Timeout') || message.includes('timeout')) {
                this.error = `⏱️ ${message}\n\n💡 Il server impiega troppo tempo a rispondere.\nVerifica le performance del database.`;
            } else if (message.includes('Network Error')) {
                this.error = `🌐 ${message}\n\n💡 Problema di rete.\nVerifica la connessione internet.`;
            } else if (message.includes('401')) {
                this.error = '🔐 Sessione scaduta. Effettua nuovamente il login.';
            } else if (message.includes('404')) {
                this.error = '📄 Endpoint non trovato. Verifica le route del backend.';
            } else if (message.includes('500')) {
                this.error = '⚠️ Errore interno del server. Controlla i log di Laravel.';
            } else {
                this.error = `❌ ${message}\n\nControlla la console per maggiori dettagli.`;
            }
        },

        toggleSezione(sezione) {
            this.visibileSezioni[sezione] = !this.visibileSezioni[sezione];
        },

        resetPagination() {
            this.currentPageLetture = 1;
            this.currentPageMensilita = 1;
            this.currentPageDettagli = 1;
        },

        async caricaFattura() {
            console.log('=== INIZIO caricaFattura GAS ===');
            this.isLoading = true;
            this.error = null;
            const seq = ++this.loadRequestSeq;

            try {
                const id = this.$route.params.id || this.$route.query.id || null;
                console.log('ID estratto GAS:', id);

                if (!this.previewFattureService) {
                    throw new Error('Service GAS non inizializzato');
                }

                console.log('Chiamata API GAS in corso...');

                const checkFattura = this.getCheckFattura();
                const response = await this.previewFattureService.getDettaglioFattura(id, checkFattura, 0);

                if (seq !== this.loadRequestSeq) return;

                this.applyFatturaResponse(response);

            } catch (error) {
                if (seq !== this.loadRequestSeq) return;
                this.handleLoadError(error);
            } finally {
                if (seq === this.loadRequestSeq) {
                    this.isLoading = false;
                }
                console.log('Loading GAS terminato, isLoading:', this.isLoading);
                console.log('Errore finale:', this.error);
            }
        },

        async caricaProssimaFattura() {
            console.log('=== INIZIO caricaProssimaFattura GAS ===');
            this.isLoading = true;
            this.error = null;
            const seq = ++this.loadRequestSeq;

            try {
                if (!this.previewFattureService) {
                    throw new Error('Service GAS non inizializzato');
                }

                const checkFattura = this.getCheckFattura();
                const response = await this.previewFattureService.getNextFattura(checkFattura, 0);

                if (seq !== this.loadRequestSeq) return;
                this.applyFatturaResponse(response);
            } catch (error) {
                if (seq !== this.loadRequestSeq) return;
                this.handleLoadError(error);
            } finally {
                if (seq === this.loadRequestSeq) {
                    this.isLoading = false;
                }
            }
        },

        updateStatoFattura(action) {
            if (!this.dettagliFattura) return;
            this.azioneValidazione = action;
            this.noteValidazione = '';
            this.validazioneError = null;
            this.noteValidazioneError = null;
            this.showValidazioneModal = true;
        },

        async validaFattura() {
            if (!this.dettagliFattura || this.validazioneInProgress) return;

            this.validazioneInProgress = true;
            this.validazioneError = null;
            this.noteValidazioneError = null;

            if (!this.noteValidazione || this.noteValidazione.trim() === '') {
                this.noteValidazioneError = 'Le note sono obbligatorie';
                this.validazioneInProgress = false;
                return;
            }

            if (this.noteValidazione.trim().length < 5) {
                this.noteValidazioneError = 'Le note devono contenere almeno 5 caratteri';
                this.validazioneInProgress = false;
                return;
            }

            try {
                console.log('🔄 Validazione fattura GAS in corso...', {
                    id: this.dettagliFattura.autofattura_id,
                    azione: this.azioneValidazione,
                    note: this.noteValidazione.trim()
                });

                const response = await this.previewFattureService.updateStatoFattura(
                    this.dettagliFattura.autofattura_id,
                    this.azioneValidazione,
                    false,
                    this.noteValidazione.trim()
                );

                if (response.data.success) {
                    this.successAction = this.azioneValidazione;
                    this.successFatturaNumero = this.dettagliFattura.numero;
                    this.successFatturaCliente = this.formatNomeCliente(
                        this.dettagliFattura.ragsoc,
                        this.dettagliFattura.nome,
                        this.dettagliFattura.cognome
                    );

                    this.showSuccessModal = true;
                    this.showValidazioneModal = false;

                    console.log('✅ Fattura GAS validata con successo');
                } else {
                    this.validazioneError = response.data.message || 'Errore nell\'elaborazione della richiesta';
                }
            } catch (error) {
                console.error('❌ Errore validazione fattura GAS:', error);
                this.validazioneError = error.message || 'Errore nella comunicazione con il server';
            } finally {
                this.validazioneInProgress = false;
            }
        },

        async continuaConQuestaFattura() {
            if (!this.dettagliFattura || this.validazioneInProgress) return;

            this.validazioneInProgress = true;
            this.validazioneError = null;

            try {
                const response = await this.previewFattureService.updateStatoFattura(
                    this.dettagliFattura.autofattura_id,
                    this.azioneValidazione,
                    true,
                    this.noteValidazione.trim()
                );

                if (response.data.success) {
                    this.showValidazioneModal = false;
                    this.caricaFattura();
                } else {
                    this.validazioneError = response.data.message || 'Errore nell\'elaborazione della richiesta';
                }
            } catch (error) {
                this.validazioneError = error.message || 'Errore nella comunicazione con il server';
            } finally {
                this.validazioneInProgress = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('it-IT');
            } catch (error) {
                return '-';
            }
        },

        formatCurrency(value) {
            if (!value && value !== 0) return '-';
            try {
                return new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(value);
            } catch (error) {
                return '-';
            }
        },

        formatNumber(value) {
            if (!value && value !== 0) return '-';
            try {
                return new Intl.NumberFormat('it-IT', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 6
                }).format(value);
            } catch (error) {
                return '-';
            }
        },

        formatBoolean(value) {
            if (value === null || value === undefined) return '-';
            if (value === 1 || value === true || value === 'true' || value === '1') return 'SI';
            if (value === 0 || value === false || value === 'false' || value === '0') return 'NO';
            return value || '-';
        },

        formatPercentage(value) {
            if (!value && value !== 0) return '-';
            return `${parseFloat(value).toFixed(0)}%`;
        },

        formatPeriodo(dateString) {
            if (!dateString) return '-';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('it-IT', {
                    month: 'long',
                    year: 'numeric'
                }).toUpperCase();
            } catch (error) {
                return '-';
            }
        },

        formatNomeCliente(ragsoc, nome, cognome) {
            return ragsoc || `${nome || ''} ${cognome || ''}`.trim() || 'Cliente senza nome';
        },

        navigateToClienteDetail(id) {
            if (!id) return;
            window.open(`/ask/clienti/${id}/dettagli`, '_blank');
        },

        navigateToPdrDetail(id) {
            if (!id || id <= 0) return;
            window.open(`/ask/pdrs/${id}/dettagli`, '_blank');
        },

        navigateToFatturaDetail(numero) {
            if (!numero) return;
            window.open(`/ask/clienti/fatture/${numero}/dettagli`, '_blank');
            // clienti/fatture/{numero}/dettagli
        },

        navigateToRappresentanteDetail(id) {
            if (!id) return;
            window.open(`/ask/rappresentanti/${id}/dettagli`, '_blank');
        },

        navigateToAgenteDetail(id) {
            if (!id) return;
            window.open(`/ask/agenti/${id}/dettagli`, '_blank');
        },

        isConsumoAnomalo() {
            if (!this.dettagliFattura) return false;
            const qta = parseFloat(this.dettagliFattura.preview_totale_qta) || 0;
            const prog = parseFloat(this.dettagliFattura.prog_annuo) || 0;
            return qta > (prog / 12);
        },

        isImponibileAnomalo() {
            if (!this.dettagliFattura) return false;
            return (
                (parseFloat(this.dettagliFattura.imponibile) || 0) >
                (parseFloat(this.dettagliFattura.maxfatt) || 0)
            );
        },

        async mostraStoriaValidazioni() {
            if (!this.dettagliFattura) return;
            this.showStoriaValidazioniModal = true;
            this.caricamentoStoriaValidazioni = true;

            try {
                const response = await this.previewFattureService.getValidazioni(this.dettagliFattura.autofattura_id);
                if (response.data.success) {
                    this.storiaValidazioni = response.data.data || [];
                }
            } catch (error) {
                console.error('Errore richiesta validazioni GAS:', error);
            } finally {
                this.caricamentoStoriaValidazioni = false;
            }
        },

        downloadPDF() {
            console.log('Download PDF per fattura GAS:', this.dettagliFattura.numero);
        },

        viewPDF() {
            console.log('Visualizza PDF per fattura GAS:', this.dettagliFattura.numero);
        },

        closeSuccessModal() {
            this.showSuccessModal = false;
        },

        loadNextInvoice() {
            console.log('🔄 Caricamento prossima fattura GAS...');
            this.showSuccessModal = false;
            this.showValidazioneModal = false;
            this.caricaProssimaFattura();
        },

        async onMensilitaRealeUsed2(podId, mensilitaId) {
            try {
                const response = await this.previewFattureService.mensilitaRealeUsed2(podId, mensilitaId);
                if (response.success) {
                    
                    await this.caricaFattura();
                }
            } catch (error) {
                console.error('Errore nel marcare mensilità come Used 2:', error);
            }
        },

        debugFattura() {
            console.log('=== DEBUG FATTURA GAS ===');
            console.log('Dettagli fattura:', this.dettagliFattura);
            console.log('Numero letture:', this.dettagliFattura.letture?.length || 0);
            console.log('Numero mensilità:', this.dettagliFattura.mensilita_reali?.length || 0);
            console.log('Numero dettagli:', this.dettagliFattura.dettagli_fattura?.length || 0);
            console.log('Service inizializzato:', !!this.previewFattureService);
        }
    },

    watch: {
        'dettagliFattura.letture'() {
            this.currentPageLetture = 1;
        },
        'dettagliFattura.mensilita_reali'() {
            this.currentPageMensilita = 1;
        },
        'dettagliFattura.dettagli_fattura'() {
            this.currentPageDettagli = 1;
        }
    },

    created() {
        console.log('=== CREATED HOOK GAS ===');

        try {
            const tipoValidazione = this.$route.query.tipo || 'gas';

            if (!this.$http) {
                console.error('$http non disponibile!');
                this.error = 'Servizio HTTP non disponibile';
                this.isLoading = false;
                return;
            }

            if (tipoValidazione === 'gas') {
                this.previewFattureService = new PreviewFattureGasService(this.$http, this.$eventBus);
                console.log('✅ Inizializzato PreviewFattureGasService');
            } else {
                this.previewFattureService = new PreviewFattureGasService(this.$http, this.$eventBus);
                console.log('✅ Inizializzato PreviewFattureGasService (fallback)');
            }

            console.log('🚀 Avvio caricaFattura GAS...');
            this.caricaFattura();

        } catch (error) {
            console.error('❌ Errore in created() GAS:', error);
            this.error = 'Errore durante l\'inizializzazione: ' + error.message;
            this.isLoading = false;
        }
    },

    mounted() {
        console.log('✅ Componente PreviewFattureGas montato');
        console.log('Route params:', this.$route.params);
        console.log('Route query:', this.$route.query);
        console.log('Service disponibile:', !!this.previewFattureService);
    },

    beforeUnmount() {
        console.log('🔄 Componente PreviewFattureGas smontato');
    }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

* {
    font-family: 'Montserrat', sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.fatturazione-dashboard {
    max-width: 1800px;
    margin: 0 auto;
    padding: 1.5rem;
    background-color: #eef2f7;
    min-height: 100vh;
}

.dashboard-title {
    font-size: 2.8rem !important;
    font-weight: 700 !important;
    color: #0d3c61 !important;
    margin: 0 0 1.5rem 0 !important;
    font-family: 'Montserrat', sans-serif !important;
    letter-spacing: -0.02em !important;
    position: relative !important;
    text-align: center !important;
    padding-bottom: 1rem !important;
}

.dashboard-title::after {
    content: '' !important;
    position: absolute !important;
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 100px !important;
    height: 4px !important;
    background: linear-gradient(90deg, #3288b3, #215159, #0d3c61) !important;
    border-radius: 2px !important;
}

.cards-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.info-card {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.info-card:hover {
    box-shadow: 0 8px 30px rgba(13, 60, 97, 0.15);
    transform: translateY(-2px);
}

.solo-header {
    background-color: transparent !important;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1) !important;
}

.info-card-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;
}

.info-card-header:hover {
    background: linear-gradient(135deg, #1a5490, #0d3c61);
}

.info-card-header.solo {
    border-radius: 12px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
}

.toggle-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 0.9rem;
    color: white;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.toggle-icon:hover {
    background-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.info-card-content {
    padding: 1.5rem;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e8eef5;
    gap: 1rem;
}

.info-row:last-child {
    border-bottom: none;
}

.info-row.important {
    background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
    border-left: 4px solid #3388b3;
    margin: 0.5rem -1rem;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(51, 136, 179, 0.1);
}

.info-label {
    font-weight: 600;
    color: #0d3c61;
    min-width: 140px;
    flex-shrink: 0;
}

.info-value {
    font-weight: 500;
    color: #2c5282;
    text-align: right;
    flex: 1;
}

.numero-fattura-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.numero-fattura {
    font-weight: 600;
    flex: 1;
}

.fattura-actions {
    display: flex;
    gap: 0.5rem;
    margin-left: 1rem;
}

.error-border {
    border: 2px solid #e74c3c !important;
    box-shadow: 0 0 5px rgba(231, 76, 60, 0.3);
}

.field-error {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 4px;
    font-style: italic;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #2c3e50;
}

.action-btn {
    background: white;
    border: 1px solid;
    padding: 0.4rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.download-btn {
    border-color: #dc3545;
    color: #dc3545;
}

.download-btn:hover {
    background: #dc3545;
    color: white;
    transform: translateY(-1px);
}

.view-btn {
    border-color: #6c757d;
    color: #6c757d;
}

.view-btn:hover {
    background: #6c757d;
    color: white;
    transform: translateY(-1px);
}

.used2-btn {
    border-color: #ffc107;
    color: #ffc107;
}

.used2-btn:hover {
    background: #ffc107;
    color: white;
    transform: translateY(-1px);
}

.link-pod {
    color: #3388b3;
    text-decoration: none;
    transition: all 0.2s;
    font-weight: 500;
}

.link-pod:hover {
    color: #0d3c61;
    text-decoration: underline;
}

.consumo-values {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.consumo-item {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 100px;
}

.consumo-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #3388b3;
    margin-bottom: 0.25rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.consumo-value {
    font-weight: 700;
    font-size: 1rem;
    color: #0d3c61;
}

.fatture-table-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    overflow: hidden;
    margin-bottom: 2rem;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.fatture-table-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.fatture-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, #f8fafc, #e2e8f0);
}

.summary-item {
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}

.summary-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.summary-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
}

.summary-item:nth-child(1)::before {
    background: #3498db;
}

.summary-item:nth-child(2)::before {
    background: #2ecc71;
}

.summary-item:nth-child(3)::before {
    background: #f39c12;
}

.summary-label {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
    margin-right: 10px;
}

.summary-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0d3c61;
}

.fatture-table-wrapper {
    overflow-x: auto;
    max-width: 100%;
}

.fatture-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
    min-width: 800px;
}

.fatture-table thead {
    background: linear-gradient(135deg, #e1edf7, #d1e3f4);
}

.fatture-table th {
    padding: 1rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #0d3c61;
    border-bottom: 2px solid #c5d3e4;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.fatture-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e8eef5;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
}

.fatture-table tbody tr:nth-child(even) {
    background-color: #f8fafc;
}

.fatture-table tbody tr:hover {
    background-color: #e8f4fd;
    transition: background-color 0.2s ease;
}

.text-center {
    text-align: center !important;
}

.status-icon {
    font-weight: bold;
    font-size: 1rem;
}

.status-icon.success {
    color: #22c55e;
}

.status-icon.error {
    color: #ef4444;
}

.no-data-message {
    text-align: center;
    padding: 2rem;
    color: #64748b;
    font-style: italic;
}

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background: #f8fafc;
    border-top: 1px solid #e8eef5;
}

.pagination-info {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 500;
}

.pagination-controls {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.pagination-btn {
    background: white;
    border: 1px solid #d1d5db;
    color: #374151;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
}

.pagination-btn:disabled {
    background: #f9fafb;
    color: #d1d5db;
    cursor: not-allowed;
    border-color: #e5e7eb;
}

.page-indicator {
    padding: 0.5rem 1rem;
    font-weight: 600;
    color: #0d3c61;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    min-width: 80px;
    text-align: center;
}

.fattura-controls-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    padding: 1.5rem;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.approval-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.approval-button {
    padding: 0.875rem 2rem;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 160px;
    position: relative;
    overflow: hidden;
}

.approve-button {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: white;
}

.approve-button:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(34, 197, 94, 0.3);
}

.reject-button {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.reject-button:hover {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(239, 68, 68, 0.3);
}

.consumo-fatturato-rosso,
.potenza-fatturata-rosso,
.imponibile-fattura-rosso {
    background: linear-gradient(135deg, #fef2f2, #fee2e2) !important;
    color: #dc2626 !important;
    font-weight: 700 !important;
    padding: 0.5rem 0.75rem !important;
    border-radius: 6px !important;
    border: 1px solid #fca5a5 !important;
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1) !important;
}

.consumo-anomalo,
.potenza-anomala,
.imponibile-anomalo {
    background: linear-gradient(135deg, #fef2f2, #fee2e2) !important;
    border-left-color: #dc2626 !important;
    border-left-width: 4px !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.modal-header-approve {
    background: linear-gradient(135deg, #22c55e, #16a34a);
}

.modal-header-reject {
    background: linear-gradient(135deg, #ef4444, #dc2626);
}

.close-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 1.2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.modal-body {
    padding: 1.5rem;
}

.compact-body {
    padding: 1.5rem;
}

.modal-message {
    font-size: 1rem;
    margin-bottom: 1rem;
    line-height: 1.5;
    color: #374151;
}

.form-group {
    margin-bottom: 1rem;
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #0d3c61;
}

.form-group textarea {
    width: 100%;
    padding: 0.75rem;
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.9rem;
    resize: vertical;
    transition: all 0.2s;
    border: 1px solid #d1d5db;
}

.textarea-approve {
    border: 2px solid #27ae60;
}

.textarea-reject {
    border: 2px solid #e74c3c;
}

.textarea-approve:focus {
    outline: none;
    border-color: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

.textarea-reject:focus {
    outline: none;
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.modal-footer {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    border-top: 1px solid #e5e7eb;
    background: #f8fafc;
}

.btn-cancel,
.btn-submit,
.btn-success,
.btn-secondary,
.btn-success-approve,
.btn-success-reject {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    position: relative;
    overflow: hidden;
}

.btn-cancel {
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
}

.btn-cancel:hover {
    background: #e5e7eb;
}

.btn-secondary {
    background: #64748b;
    color: white;
    min-width: 140px;
}

.btn-secondary:hover {
    background: #475569;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(100, 116, 139, 0.3);
}

.btn-approve {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: white;
}

.btn-approve:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    transform: translateY(-1px);
}

.btn-reject {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.btn-reject:hover {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-1px);
}

.btn-success-approve {
    background: #22c55e;
    color: white;
}

.btn-success-approve:hover {
    background: #16a34a;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(34, 197, 94, 0.4);
}

.btn-success-reject {
    background: #ef4444;
    color: white;
}

.btn-success-reject:hover {
    background: #dc2626;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.btn-secondary::before,
.btn-success::before,
.btn-success-approve::before,
.btn-success-reject::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transition: all 0.4s ease;
    transform: translate(-50%, -50%);
}

.btn-secondary:active::before,
.btn-success:active::before,
.btn-success-approve:active::before,
.btn-success-reject:active::before {
    width: 120%;
    height: 120%;
}

.btn-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none !important;
}

.error-message {
    color: #dc2626;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 0.75rem;
    margin-top: 1rem;
    font-size: 0.9rem;
}

.success-message {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #374151;
}

.success-details {
    font-size: 0.9rem;
    color: #64748b;
    line-height: 1.5;
}

.totali-row {
    font-size: medium;
    background-color: #bdd3e7;
    color: white;
}

@media (max-width: 1200px) {
    .fatturazione-dashboard {
        max-width: 100%;
        padding: 1rem;
    }

    .fatture-table {
        font-size: 0.8rem;
        min-width: 700px;
    }
}

@media (max-width: 768px) {
    .cards-container {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .fatture-summary {
        grid-template-columns: 1fr;
        padding: 1rem;
    }

    .approval-actions {
        flex-direction: column;
    }

    .approval-button {
        width: 100%;
    }

    .pagination-container {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .dashboard-title {
        font-size: 1.5rem;
    }

    .fatture-table {
        font-size: 0.75rem;
        min-width: 600px;
    }

    .fatture-table th,
    .fatture-table td {
        padding: 0.5rem 0.25rem;
    }
}

@media (max-width: 480px) {
    .fatturazione-dashboard {
        padding: 0.5rem;
    }

    .info-card-content {
        padding: 1rem;
    }

    .info-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.25rem;
    }

    .info-row.important {
        margin: 0.5rem -0.5rem;
        padding: 0.75rem 1rem;
    }

    .numero-fattura-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .fattura-actions {
        margin-left: 0;
    }

    .modal-content {
        width: 95%;
        margin: 1rem;
    }

    .modal-footer {
        flex-direction: column;
        gap: 0.75rem;
    }

    .btn-cancel,
    .btn-submit,
    .btn-secondary,
    .btn-success-approve,
    .btn-success-reject {
        width: 100%;
        justify-content: center;
        min-width: auto;
    }
}
</style>
